import { render, staticRenderFns } from "./BidStrategiesSubtypeMappingsData.vue?vue&type=template&id=b1aafa60"
import script from "./BidStrategiesSubtypeMappingsData.vue?vue&type=script&lang=js"
export * from "./BidStrategiesSubtypeMappingsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports